import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import {
    AUTH0_CALLBACK_PATH,
    consumeAuth0CandidateSafeReturn,
    consumeAuth0SafeReturn,
} from "../lib/safeReturn";

const CANDIDATE_CALLBACK_PATH = "/auth/callback";
const CANDIDATE_LOGIN_PATH = "/auth/login";

export const Auth0ProviderWithNavigate = ({
    children,
    deploymentProfile = __PINPOINT_DEPLOYMENT_PROFILE__,
}) => {
    const navigate = useNavigate();

    const domain = import.meta.env.VITE_AUTH0_DOMAIN?.trim();
    const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID?.trim();
    const audience = import.meta.env.VITE_AUTH0_AUDIENCE?.trim();
    const isCandidate = deploymentProfile === "www-candidate";
    const callbackPath = isCandidate ? CANDIDATE_CALLBACK_PATH : AUTH0_CALLBACK_PATH;
    const redirectUri = `${window.location.origin}${callbackPath}`;

    const onRedirectCallback = (appState) => {
        if (isCandidate) {
            const returnTo = consumeAuth0CandidateSafeReturn(appState?.returnTo);
            navigate(
                CANDIDATE_LOGIN_PATH,
                returnTo ? { replace: true, state: { returnTo } } : { replace: true },
            );
            return;
        }
        navigate(consumeAuth0SafeReturn(appState?.returnTo), { replace: true });
    };

    if (!(domain && clientId && audience && redirectUri)) {
        console.error("Required Product authentication configuration is missing");
        return (
            <div role="alert" className="p-4 text-red-500 font-bold">
                Authentication configuration is unavailable. Please contact support.
            </div>
        );
    }

    return (
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            authorizationParams={{
                redirect_uri: redirectUri,
                audience: audience,
                scope: "openid profile email",
            }}
            cacheLocation="localstorage"
            onRedirectCallback={onRedirectCallback}
        >
            {children}
        </Auth0Provider>
    );
};
